//let baseURL = "http://127.0.0.1:8000/api";

export const LOGIN = "/login-client";
export const SEND_PASSWORD = "/send-password-client";
